<template>
  <section id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">
        <div class="xblock layui-form">
          <button class="layui-btn xblock-row" lay-filter="sreach" v-on:click="AddPricing('添加定价模板')">添加模板</button>
          <span class="x-right xblock-row" v-text="'　共有数据：'+count+ '条'"></span>
          <div class="clear-both"></div>
        </div>

        <table class="layui-table">
          <thead>
            <tr>
              <th>模板名称</th>
              <th>利润类型</th>
              <th>其它费用</th>
              <th>利润</th>
              <th>总佣金(%)</th>
              <th>折扣</th>
              <th>创建时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr class="order_box" v-for="(item,index) in list" v-bind:key="index">
              <td>
                <i v-if="item.name" v-text="item.name"></i>
                <i v-else v-text="'定价模板'+item.id"></i>
              </td>
              <td>
                <i v-if="item.e_type == 1">支出利润率</i>
                <i v-else-if="item.e_type == 2">固定利润</i>
                <i v-else>订单利润率</i>
              </td>
              <td v-text="item.other_fee"></td>
              <td>
                <i v-if="item.e_type == 1 || item.e_type == 3" v-text="item.profit+'%'"></i>
                <i v-if="item.e_type == 2" v-text="item.profit+'元'"></i>
              </td>
              <td v-text="item.system_fee"></td>
              <td v-text="item.discounts"></td>
              <td v-text="item.created_at"></td>
              <td class="btn-arr">
                <button class="layui-btn layui-btn-primary" v-if="item.is_default == 0" v-on:click="ConfirmHint(2,item)">设置默认</button>
                <button class="layui-btn" v-else>当前默认</button>
                <button class="layui-btn layui-btn-normal" v-on:click="EditItem(item)">编辑</button>
                <button class="layui-btn layui-btn-danger" v-on:click="ConfirmHint(1,item)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

      </div>

    </div>

    <!-- 分页 -->
    <div class="page-box"><div id="pagebox" class="pagebox"></div></div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

  </section>
</template>

<script>
  var self, form, layer, laypage;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'Pricing',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        item: null,
        isLoding:true,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        total: 0,
        page_num:20,
        current_status: 0,
        status_id: 0,
        list: [],
        data_total: {
          amount_invested: 0,
          escrow_amount: 0,
          total_amount: 0,
          profit: 0,
          profit_margin: 0
        },
        status: [{
          id: 1,
          name: "打包"
        }]
      }
    },
    mounted() {
      self = this;
      self.SetNavActive("上架",self.$route.name);
      layui.use(['form', 'layer', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        form.on('select(status_selection)', function(data) {
          var val = $("select[name=status").val() - 1;
          self.current_status = val;
          var status;
          if (val != -1) {
            status = self.status[self.current_status].id;
          } else {
            status = 0;
          }

          self.status_id = status; //获取当前站点
          self.get_consumption_record(true)
        });
        form.render('select');


        //保存定价模板
        form.on('submit(PricingSubmit)', function(data) {

          let shopte = $('#ShopType input[name="ShopType"]:checked').val()
          var FreeShip =$('.FreeShip').get(0).checked;
          var Cbb =$('.Cbb').get(0).checked;
          var Hatch =$('.Hatch').get(0).checked;
          var name = $("#PricingName").val();
          var profit_margin = $("#profit_margin").val();
          var profit_margin_order = $("#profit_margin_order").val();
          var profit = $("#profit").val();
          var other_fee = $("#other_fee").val();
          var pay_fee = $("#pay_fee").val();
          var discounts = $("#discounts").val();
          var ws_handle = $("#mantissa").val();
          var ws_money = $("#mantissa_money").val();

          if(isNaN(discounts)){
            layer.msg("折扣必须为数字！");
            $("#discounts").val("")
            return;
          }
          if(discounts > 9.9){
            layer.msg("折扣不能低于9.9折");
            $("#discounts").val("")
            return;
          }
          if(discounts < 0){
            layer.msg("折扣不正确");
            $("#discounts").val("")
            return;
          }

          //定价类型
          var PricingType = $('#PricingType input[name="PricingType"]:checked').val()
          let param = new URLSearchParams()
          param.append('is_fee_ship', FreeShip)
          param.append('is_ccb', Cbb)
          param.append('is_support', Hatch)
          param.append('ws_handle', ws_handle)
          param.append('ws_money', ws_money)

          var count = Number(pay_fee);
          if(FreeShip){
            count += 6;
          }
          if(Cbb){
            count += 3;
          }
          if(!Hatch){
            count += 7;
          }
          param.append('system_fee', count);

          param.append('e_type', PricingType)
          if (PricingType == 1) {
            if(profit_margin){
              if(isNaN(profit_margin)){
                self.ToastFun(2, "利润率只能为数字！");
                $("#profit_margin").val("");
                return;
              }
              param.append('profit', profit_margin)
            }else{
              self.ToastFun(2, "利润率不能为空！");
              return;
            }
          }
          if (PricingType == 2) {
            if(profit){
              if(isNaN(profit)){
                self.ToastFun(2, "利润只能为数字！");
                $("#profit").val("");
                return;
              }
              param.append('profit', profit)
            }else{
              self.ToastFun(2, "利润不能为空！");
              return;
            }
          }
          if (PricingType == 3) {
            if(profit_margin_order){
              if(isNaN(profit_margin_order)){
                self.ToastFun(2, "利润率只能为数字！");
                $("#profit_margin_order").val("");
                return;
              }
              param.append('profit', profit_margin_order)
            }else{
              self.ToastFun(2, "利润率不能为空！");
              return;
            }
          }
          if(other_fee){
            if(isNaN(other_fee)){
              self.ToastFun(2, "其它费用只能为数字！");
              $("#other_fee").val("");
              return;
            }
            param.append('other_fee', other_fee)
          }
          if(discounts){
            if(isNaN(discounts)){
              self.ToastFun(2, "折扣只能为数字！");
              $("#discounts").val("");
              return;
            }
            param.append('discounts', discounts)
          }
          if(name){
            param.append('name', name)
          }
          param.append('pay_fee', pay_fee)
          if(self.item){ //编辑
            param.append('id', self.item.id);
            param.append('is_default', self.item.is_default);
          }

          self.loading = true;
          axios({
            method: 'post',
            url: self.GetServerUrl() + "/price_template_store/",
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {

            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              self.GetList();
              self.modal_box_close();
              self.ToastFun(0, "操作成功！"); //弹窗提醒
            }, false, true);

          }).catch(function(error) {
            self.loading = false;
            console.log(error);
          })
        });

        //尾数处理
        form.on('select(mantissa)', function(data) {
          if(data.value > 0){
            $(".mantissa_money").show();
          }else{
            $(".mantissa_money").hide();
          }
        });

        self.GetList()
      });
    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      GetList() {
        self.isLoding = true;
        let param = new URLSearchParams()
        param.append('num', self.page_num)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/price_template_list/?page=" + self.page,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            if (datas.page) {
              self.list = datas.list;
              self.total = datas.total;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "GetList"); //分页
              $('.pagebox').show();
            }
          }, function() {
            self.list = [];
            $('.pagebox').hide();

            //自动换页
            if (self.page > 1) {
              self.page -= 1;
              self.GetList();
            }
          });

        }).catch(function(error) {
          self.isLoding = false;
          console.log(error);
        })
      },
      AddPricing(title) {
        self.item = null;
        self.modal_box_show(self, 'Pricing', title);
      },
      ConfirmHint(te,item) {
        self.Confirm.style = te;
        self.Confirm.state = true;
        if(te == 1){
          self.Confirm.txt = "是否确认删除？"
        }else{
          self.Confirm.txt = "是否确认设置为默认定价模板？"
        }
        self.item = item;
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (data.state) {
          self.loading = true;
          var url;
          self.Confirm.state = false;
          let param = new URLSearchParams()
          param.append('id', self.item.id)
          var url = "/price_template_del/"
          if (self.Confirm.style == 2) {
            url = "/price_template_store/"
            param.append('is_default', 1)
          }
          self.loading = true;
          axios({
            method: 'post',
            url: self.GetServerUrl() + url,
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {

            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              self.GetList();
            },false,true);

          }).catch(function(error) {
            self.loading = false;
            console.log(error);
          })


        }
      },
      EditItem (item) {
        self.item = item;
        self.modal_box_show(self, 'Pricing', "编辑定价模板", item);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/Pricing.vue